export default "__VITE_ASSET__DGIRrqbW__"